import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useTranslation } from "../../context/TranslationContext";
import EmptyState from "../ds/EmptyState";
import { ReviewSubmissionRow, SubmissionDialogs, SubmissionFilters } from "./SubmissionRows";
import useSubmissionActions from "./useSubmissionActions";

/** Figma O2: everything creators sent to one campaign, to approve or reject. */
const SubmissionsReview = ({ submissions, setSubmissions, refresh, platforms, setToast, isDark }) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const actions = useSubmissionActions({ setToast, refresh, setSubmissions });
  const [status, setStatus] = useState("all");
  const [platform, setPlatform] = useState("all");

  const shown = submissions.filter(
    (row) => (status === "all" || row.status === status) && (platform === "all" || row.platform === platform)
  );

  return (
    <section className="flex flex-col gap-space-16">
      <SubmissionFilters
        submissions={submissions}
        status={status}
        onStatus={setStatus}
        platform={platform}
        onPlatform={setPlatform}
        platforms={platforms}
      />
      {shown.length === 0 ? (
        <div className="rounded-radius-lg bg-bg-raised">
          <EmptyState icon="upload" title={t("campaignFlow.noReviewTitle")} message={t("mintSpace.submissionsWillAppear")} />
        </div>
      ) : (
        <ul className="flex flex-col divide-y divide-separator-default rounded-radius-lg bg-bg-raised py-space-8">
          {shown.map((submission) => (
            <ReviewSubmissionRow key={submission._id} submission={submission} ownId={user?._id || user?.id} actions={actions} />
          ))}
        </ul>
      )}
      <SubmissionDialogs actions={actions} isDark={isDark} />
    </section>
  );
};

export default SubmissionsReview;
